import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

class SurveyController extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props

    this.formatMessage = formatMessage

    this.state = {
      running: false,
      open: false,
      alreadyShown: false
    }
    this.timeout = {}
    this.interval = {}
  }

  componentDidMount() {
    if (this.props.shouldOpen) {
      this.initializeCountdown()
    }
  }

  componentDidUpdate() {
    if (this.props.shouldOpen) {
      this.initializeCountdown()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
    clearInterval(this.interval)
  }

  initializeCountdown() {
    if (!this.state.running) {
      let timeLeftToOpen = this.props.timeLeftToOpen

      //Interval for debugging purposes only
      // let time = timeLeftToOpen
      // this.interval = setInterval(() => {
      //   time--
      //   console.log('Countdown', time)
      //   if (time < 0) clearInterval(this.interval)
      // }, 1000)

      this.timeout = setTimeout(() => {
        const timesShown = Number(localStorage.getItem('surveyTimesShown'))
        sessionStorage.setItem('surveyAlreadyShown', true)
        localStorage.setItem('surveyTimesShown', timesShown + 1)
        this.setState({
          open: true,
          alreadyShown: true
        })
      }, timeLeftToOpen * 1000)

      this.setState({ running: true })
    }
  }

	closeSurvey = () => {
	  this.setState({
	    open: false
	  })
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : ''
	  const bottom = '10%'

	  if (this.state.alreadyShown) {
	    renderingComponent = (
	      <div
	        className={`ork-access-to-survey ${this.state.open ? 'animated faster slideInLeft' : 'animated faster slideOutLeft'}`}
	        style={{ position: 'fixed', top: 'auto', bottom: bottom }}
	      >
	        <button className="ork-access-to-survey__close js-ork-access-to-survey__close">
	          <i className="fal fa-times fa-2x" onClick={this.closeSurvey} />
	        </button>
	        <p className="ork-access-to-survey__logo-wrapper">
	          <img src={BASE_URL + this.formatMessage(messages.logo)} alt="Observatorio de competitividad" />
	        </p>
	        <p>
	          <span className="ork-access-to-survey__highlighted text-primary">{this.formatMessage(messages.hello)}</span>
	        </p>
	        <p>
	          <i>{this.formatMessage(messages.thanks)}</i>
	        </p>
	        <p>
	          <span className="ork-access-to-survey__highlighted text-primary">{this.formatMessage(messages.helpUs)}</span>
	        </p>
	        <p>
	          <i>{this.formatMessage(messages.thanksAgain)}</i>
	        </p>
	        <p className="ork-u-mt-2">
	          <a href={this.formatMessage(messages.surveyLink)} role="button" className="btn btn-warning" target="_blank" rel="noopener">
	            <i className="fal fa-pencil-alt fa-lg" />
							&nbsp;
	            {this.formatMessage(messages.yes)}
	          </a>
						&nbsp;
	          <a className="js-ork-access-to-survey__close" onClick={this.closeSurvey}>
	            {this.formatMessage(messages.no)}
	          </a>
	        </p>
	      </div>
	    )
	  }

	  return renderingComponent
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(SurveyController)



// WEBPACK FOOTER //
// ./src/modules/Controllers/Survey/SurveyController/SurveyController.jsx